import { fetcher } from '../utils'
import { ComponentMessageVO } from '@repo/types'

export default async (input: ComponentMessageVO): Promise<void> => fetcher(`/api/chats/message/send`, 'POST', input)
